//   {
// 	CaseNumber = 0,
// 	FirstNameInitial = 1,
// 	FirstName = 2,
// 	LastNameInitial = 3,
// 	LastNameUpTo7 = 4,
// 	LastName = 5,
// 	StageNumber = 6,
// 	Empty = 7,
// };
// 2, 根据CaseTag 所示 截取拼装字符串
//     for (int i = 0; i < tags.size(); ++i)
//     {
//         switch(tags.at(i))
//         {
//         case CaseNumber:
//         {
//             strs.push_back(caseNumber);
//             break;
//         }
//         case FirstNameInitial:
//         {
//             strs.push_back(firstName.left(1));
//             break;
//         }
//         case FirstName:
//         {
//             strs.push_back(firstName);
//             break;
//         }
//         case LastNameInitial:
//         {
//             strs.push_back(lastName.left(1));
//             break;
//         }
// 		case LastNameUpTo7:
// 		{
// 			strs.push_back(lastName.left(7));
// 			break;
// 		}
//         case LastName:
//         {
//             strs.push_back(lastName);
//             break;
//         }
//         case StageNumber:
//         {
//             strs.push_back(stageNumber);
//             break;
//         }
//         case Empty:
//         {
//             ;
//             break;
//         }
//         }
//     }
// label result
export const getLabelResult = (
  caseTag: number[],
  caseId: string,
  firstName: string,
  lastName: string,
) => {
  let str = ""
  caseTag.map((i) => {
    switch (i) {
      case 0:
        str += caseId
        break
      case 1:
        str += sliceToN(firstName, 1)
        break
      case 2:
        str += firstName
        break
      case 3:
        str += sliceToN(lastName, 1)
        break
      case 4:
        str += sliceToN(lastName, 7)
        break
      case 5:
        str += lastName
        break
      case 6:
        str += "stageNumber"
        break
      case 7:
        str += ""
        break
    }
  })
  return str
}
// left slice
const sliceToN = (str, n) => {
  return str.slice(0, n > 0 ? n : 0)
}
